import { render } from "./Broadcasting.vue?vue&type=template&id=c8bef76a"
import script from "./Broadcasting.vue?vue&type=script&lang=js"
export * from "./Broadcasting.vue?vue&type=script&lang=js"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__